import { FormattedMessage } from 'react-intl';
import { Col, Grid, Row } from 'rsuite';
import Modal from 'rsuite/Modal';

import { OpenModal } from '../../../containers/styled/alerts';
import { ViewMarginDiv } from '../../../containers/styled/layout';
import { ViewLabel, ViewLabelValue } from '../../../containers/styled/typography';
import AuditFieldsView from '../../generic/AuditFieldsView';

/**
 * Facility Category View screen
 *
 * Facility category view to display each category in-detail.
 *
 * @component
 * @param {object} item                Facility category data
 * @param {boolean} handleClose        handles modal close event
 * @returns category view modal.
 *
 */
const FacilityCategoryView = ({ item, handleClose }) => (
  <OpenModal
    data-testid='view-facility-category'
    onClose={handleClose}
    size='md'
    title={
      <FormattedMessage
        id='facility.category.details.title'
        defaultMessage='Category Details'
      />
    }
  >
    <Modal.Body style={{ marginBottom: 30 }}>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='facility.category.view.label.id'
                defaultMessage='Category ID'
              />
            </ViewLabel>
            <ViewLabelValue>{item.id}</ViewLabelValue>
          </Col>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='facility.category.view.label.name'
                defaultMessage='Category name'
              />
            </ViewLabel>
            <ViewLabelValue>{item.name}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
        <Row>
          <Col xs={12}>
            <ViewLabel>
              <FormattedMessage
                id='facility.category.view.label.details'
                defaultMessage='Details'
              />
            </ViewLabel>
            <ViewLabelValue>{item.details}</ViewLabelValue>
          </Col>
        </Row>
        <ViewMarginDiv />
      </Grid>
      <AuditFieldsView item={item} />
    </Modal.Body>
  </OpenModal>
);

export default FacilityCategoryView;
